// lcdcash-frontend/src/components/tarifs/Hero.jsx
import * as React from 'react';
import { Container, Grid, Box, Typography } from '@mui/material';
import phonesImg from '../../assets/images/phones.png';
import appleLogo from '../../assets/logo/apple-logo.png';
// import oppoLogo from '../../assets/logo/oppo-logo.png';
import samsungLogo from '../../assets/logo/samsung-logo.png';

// i18n
import { useI18n } from '../../i18n/I18nProvider';
import tarifsHeroI18n from '../../i18n/components/tarifs/hero.i18n';

const GREEN = '#0466c8';

export default function TarifsHero() {
  const { t, register } = useI18n();
  React.useEffect(() => { register('tarifs', tarifsHeroI18n); }, [register]);

  return (
    <Box
      sx={{
        bgcolor: GREEN,
        position: 'relative',
        py: { xs: 3, sm: 4, md: 6 },
        overflow: 'visible',
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative' }}>
        <Grid container alignItems="center">
          <Grid item xs={12} md={7}>
            <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
              <Typography
                component="h1"
                sx={{
                  fontSize: { xs: 24, sm: 30, md: 38 },
                  fontWeight: 800,
                  lineHeight: 1.2,
                  color: '#fff',
                }}
              >
                {t('tarifs.hero.title')}
              </Typography>

              <Box
                sx={{
                  mt: { xs: 1.5, md: 2 },
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: { xs: 'center', md: 'flex-start' },
                  gap: { xs: 3, md: 4 },
                }}
              >
                {/* <Box component="img" src={oppoLogo} alt="Oppo" sx={{ height: { xs: 16, md: 20 }, width: 'auto' }} /> */}
                <Box component="img" src={samsungLogo} alt="Samsung" sx={{ height: { xs: 24, md: 30 }, width: 'auto' }} />
                <Box component="img" src={appleLogo} alt="Apple" sx={{ height: { xs: 20, md: 26 }, width: 'auto' }} />
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Image qui sort par le bas */}
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            bottom: { xs: '-60px', md: '-140px' },
            pointerEvents: 'none',
            '@media (max-width:900px)': { display: 'none' },
          }}
        >
          <Box
            component="img"
            src={phonesImg}
            alt={t('tarifs.hero.alt.phones')}
            sx={{
              height: { md: 260, lg: 280 },
              width: 'auto',
              display: 'block',
            }}
          />
        </Box>
      </Container>
    </Box>
  );
}